var _defs, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowVerticalFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "305px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 100,
    markerHeight: 10,
    refX: 0,
    refY: 3,
    orient: "auto-start-reverse",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#bebebe"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10,
    x2: 5,
    y2: "98%",
    stroke: "#bebebe",
    strokeWidth: 1,
    markerStart: "url(#arrow)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowVerticalFull);
export default __webpack_public_path__ + "static/media/arrow-vertical-full.a544f8019878be23f9a9d3ee0749045d.svg";
export { ForwardRef as ReactComponent };